import { useCallback } from 'react';
import { StudentSectionOrSubSectionOverview } from '../student/student.constants';
import { getActivityDetailsFromOverview } from './get-activity-details-from-overview';
import { getActivityTitle } from './get-activity-title';
import { ActivitiesContentType } from 'global/constants';
import { SectionOrSubSectionOverview } from '../activity-builder.constants';
import { useDifferentiationTranslation } from 'approot/shared/differentiation/use-differentiation-translation';

type Props = {
  sectionsOverview:
    | SectionOrSubSectionOverview[]
    | StudentSectionOrSubSectionOverview[];
  contentType: ActivitiesContentType;
};

export const useGetActivityMetadata = ({
  sectionsOverview,
  contentType,
}: Props) => {
  const { unitQuizLabel } = useDifferentiationTranslation();

  const getMetaData = useCallback(
    (
      section: SectionOrSubSectionOverview | StudentSectionOrSubSectionOverview
    ) => {
      const details = getActivityDetailsFromOverview({
        section,
        sectionsOverview,
      });

      const { title, description } = getActivityTitle({
        differentiation: details.differentiation,
        activityNumber: details.activityNumber,
        progressLabel: details.progressLabel,
        totalSteps: details.totalSteps,
        contentType,
        unitQuizLabel,
      });

      return {
        title,
        description,
        differentiation: details.differentiation,
      };
    },
    [contentType, unitQuizLabel, sectionsOverview]
  );

  return {
    getMetaData,
  };
};
